import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import { useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import Logo from '../../assets/LOGO.png'
const Footer = () => {
  const { categories = [], loading = true, error } = useSelector(state => state.categoriesState);
  return (
    <footer className="footer-bs">
      <Container>
        <Row>
          <Col md={3} sm={12} className="footer-brand text-center text-md-start mb-4 mb-md-0">
            <img
              src={Logo}
              alt="Eternica Beauty"
              className="footer-logo img-fluid"
            />
            <p className="footer-description mt-2">
              Eternica Beauty is a trusted supplier of Doyen products and pure oils across the GCC and Middle East. We provide biodegradable and antibacterial gym wipes, Doyen dispensers, and high-quality line of carrier, essential, fragrance, and massage oils for spas, salons, and gyms fitness centers.
            </p>
          </Col>
          <Col md={3} sm={6} className="footer-nav">
            <h3>Products</h3>
            <ul>
              {categories && categories.map((category, catIndex) => {
                return (
                  <li key={catIndex}>
                    <Link to={`/${category.slug}`}>{category.name}</Link>
                  </li>
                );
              })}
              {/* <li><Link to="/Carrier-Base-Oils">Carrier & Base Oils</Link></li>
              <li><Link to="/Essential-Oil">Essential Oil</Link></li>
              <li><Link to="/Fragrance-Oi">Fragrance Oil</Link></li>
              <li><Link to="/Masage-Oil">Masage Oil</Link></li>
              <li><Link to="/Gym-Wipes">Gym Wipes</Link></li> */}
            </ul>
          </Col>
          <Col md={3} sm={6} className="footer-nav">
            <h3>Quick Links</h3>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </Col>


          <Col md={3} sm={12} className="footer-ns">
            <h3>Company</h3>
           <p>
  Eternica Beauty FZE, UAE <br />
  Phone: +971 52 398 7292 <br />
  Email:{" "}
  <a href="mailto:contact@eternicabeauty.com">
    contact@eternicabeauty.com
  </a>
</p>

            {/* <form className="subscribe-form">
              <input
                type="email"
                className="form-control"
                placeholder="Your Email"
              />
              <button type="submit" className="btn">Subscribe</button>
            </form> */}

            <div className="footer-social">
              <Link to="#"><FaFacebookF /></Link>
              <Link to="#"><FaTwitter /></Link>
              <Link to="#"><FaInstagram /></Link>
              <Link to="#"><FaLinkedinIn /></Link>
            </div>
          </Col>
        </Row>


        <Row>
          <Col className="text-center mt-3">
            <p>© {new Date().getFullYear()} Eternica Beauty. All rights reserved.</p>
          </Col>
        </Row>
      </Container>
    </footer>

  );
};

export default Footer;
